<template>
    <div>
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Video Pembelajaran' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Daftar Video</h3>

        <v-card>
            <v-card-title>
                Daftar Video
                <v-spacer></v-spacer>
                <v-btn
                    class="align-center text-body-2 blew white--text mr-2"
                    text
                    @click="createVideo()"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Video
                </v-btn>
                <v-btn
                    class="align-center text-body-2 blew white--text mr-2"
                    text
                    @click="reportVideo()"
                >
                    <v-icon small class="mr-2">mdi-chart-bell-curve</v-icon>
                    Lihat Laporan
                </v-btn>
            </v-card-title>

            <v-card-text class="px-0 py-3 border-top-1">
                <div class="mt-2">
                    <v-row
                        class="d-flex align-center flex-wrap justify-center no-gutters gap-10"
                    >
                        <v-col>
                            <v-autocomplete
                                v-model="grade"
                                height="36px"
                                hide-details
                                placeholder="Kelas"
                                dense
                                clearable
                                outlined
                                :items="gradeList"
                                @change="fetchData()"
                            ></v-autocomplete>
                        </v-col>

                        <v-col>
                            <v-autocomplete
                                v-model="kurikulum"
                                height="36px"
                                hide-details
                                placeholder="Kurikulum"
                                dense
                                clearable
                                outlined
                                :items="[
                                    { text: 'KM', value: 'KM' },
                                    { text: 'K13', value: 'K13' },
                                    { text: 'K13 IPA', value: 'SAINTEK' },
                                    { text: 'K13 IPS', value: 'SOSHUM' },
                                    { text: 'TKA', value: 'TKA' },
                                ]"
                                item-text="text"
                                item-value="value"
                                @change="fetchData()"
                            ></v-autocomplete>
                        </v-col>

                        <v-col>
                            <v-autocomplete
                                v-model="subject"
                                height="36px"
                                hide-details
                                placeholder="Mata Pelajaran"
                                clearable
                                dense
                                outlined
                                :items="mapelList"
                                item-text="nama"
                                item-value="nama"
                                @change="getMapelByName()"
                            ></v-autocomplete>
                        </v-col>

                        <v-col>
                            <v-select
                                v-model="bab"
                                height="36px"
                                hide-details
                                placeholder="Bab"
                                dense
                                clearable
                                outlined
                                :items="topics"
                                item-text="nama"
                                item-value="nama"
                                @change="fetchData()"
                            ></v-select>
                        </v-col>

                        <v-col>
                            <v-select
                                v-model="status"
                                height="36px"
                                hide-details
                                placeholder="Status"
                                dense
                                clearable
                                outlined
                                :items="[
                                    { text: 'Draft', value: 'DRAFT' },
                                    { text: 'Review', value: 'REVIEW' },
                                    { text: 'Publikasi', value: 'PUBLISHED' },
                                ]"
                                item-text="text"
                                item-value="value"
                                @change="fetchData()"
                            ></v-select>
                        </v-col>
                        <v-col>
                            <v-card
                                outlined
                                class="px-4 py-3 text-center"
                                style="border: 2px solid #f0f3f9"
                            >
                                <div class="grey--text font-weight-500">
                                    Total Video
                                </div>
                                <div
                                    class="font-weight-700 mt-1"
                                    style="font-size: 24px"
                                >
                                    {{ total_count }}
                                </div>
                            </v-card>
                        </v-col>
                        <v-col>
                            <v-card
                                outlined
                                class="px-4 py-3 text-center"
                                style="border: 2px solid #f0f3f9"
                            >
                                <div class="grey--text font-weight-500">
                                    Video Terpublikasi
                                </div>
                                <div
                                    class="font-weight-700 mt-1"
                                    style="font-size: 24px"
                                >
                                    {{ total_published }}
                                    <span class="font-size-14"> Video </span>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>

            <app-datatable
                :items="videoList"
                :headers="headers"
                :has-action="true"
                :has-export="false"
                :hasMultiSearch="true"
                :has-custom-pagination="true"
                :has-custom-search="true"
                :hasOpenNewTab="true"
                :custom-pagination-total-items="total_data"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="total_pages"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:doSearch="
                    search = $event;
                    fetchData();
                "
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="editVideo()"
                v-on:duplicateClicked="duplicateItem()"
                v-on:deleted="confirmDelete($event)"
                v-on:deleteOnFilter="delByOneFilter($event)"
                v-on:openNewTab="openNewTab($event)"
            ></app-datatable>
        </v-card>

        <v-dialog v-model="dialogConfirm.open" persistent max-width="500">
            <dialog-confirm
                :title="dialogConfirm.title"
                :subtitle="dialogConfirm.subtitle"
                @close="
                    dialogConfirm.open = false;
                    dialogConfirm.title = null;
                    dialogConfirm.function = null;
                "
                @confirm="
                    deleteVideo(dialogConfirm.function);
                    dialogConfirm.open = false;
                    dialogConfirm.title = null;
                    dialogConfirm.function = null;
                "
            />
        </v-dialog>

        <v-dialog v-model="dialogConfirm2.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ dialogConfirm2.title }}
                </v-card-title>
                <v-card-text>
                    {{ dialogConfirm2.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="dialogConfirm2.open = false"
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        v-if="dialogConfirm2.function == 'onDuplicateConfirm'"
                        color="blew"
                        text
                        @click="onDuplicateConfirm"
                    >
                        OK
                    </v-btn>
                    <v-btn
                        v-if="dialogConfirm2.function == 'onDuplicateCancel'"
                        color="blew"
                        text
                        @click="onDuplicateCancel"
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="showModal"
            transition="dialog-top-transition"
            width="900px"
            persistent
            height="168px"
            @click:outside="
                dialogConfirm2.title = 'Yakin ingin membatalkan duplikasi ?';
                dialogConfirm2.open = true;
                dialogConfirm2.function = 'onDuplicateCancel';
            "
            scrollable
        >
            <v-card>
                <v-card-title width="100%">
                    Detail Duplikat Video
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        icon
                        @click="
                            dialogConfirm2.title =
                                'Yakin ingin membatalkan duplikasi ?';
                            dialogConfirm2.open = true;
                            dialogConfirm2.function = 'onDuplicateCancel';
                        "
                        ><v-icon>mdi-close-circle</v-icon></v-btn
                    >
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-4 px-6">
                    <v-list-item two-line class="pa-0">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title class="font-weight-bold pb-2">
                                URL Video
                            </v-list-item-title>
                            <v-text-field
                                placeholder="Masukkan URL Video dan tekan enter"
                                v-model="details.youtube_url"
                                outlined
                            />
                            <div
                                style="
                                    width: 50% !important;
                                    padding: 0px 0px 20px 0px;
                                "
                            >
                                <youtube
                                    :video-id="
                                        $youtube.getIdFromUrl(
                                            details.youtube_url
                                        )
                                    "
                                    ref="youtube"
                                    @playing="playing"
                                ></youtube>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                    <div>
                        <v-list-item two-line class="pa-0">
                            <v-list-item-content class="pa-0">
                                <v-list-item-title
                                    class="font-weight-bold pa-0"
                                >
                                    Source
                                </v-list-item-title>

                                <v-radio-group row v-model="details.source">
                                    <v-radio
                                        label="Youtube"
                                        value="youtube"
                                        class="jenjang-selection"
                                        active-class="act-radio-btn"
                                    ></v-radio>
                                </v-radio-group>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line class="pa-0">
                            <v-list-item-content class="pa-0">
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Judul Video
                                </v-list-item-title>
                                <v-text-field
                                    placeholder="Judul Video"
                                    v-model="details.title"
                                    outlined
                                />
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line class="pa-0">
                            <v-list-item-content class="pa-0">
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Durasi
                                </v-list-item-title>
                                <v-text-field
                                    type="number"
                                    placeholder="Durasi (dalam detik)"
                                    v-model="details.duration"
                                    outlined
                                />
                            </v-list-item-content>
                        </v-list-item>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-end">
                    <v-btn
                        text
                        elevation="0"
                        @click="
                            dialogConfirm2.title =
                                'Yakin ingin membatalkan duplikasi ?';
                            dialogConfirm2.open = true;
                            dialogConfirm2.function = 'onDuplicateCancel';
                        "
                        >Batal</v-btn
                    >
                    <v-btn
                        dark
                        color="blew"
                        @click="
                            dialogConfirm2.title =
                                'Yakin ingin melakukan duplikasi pada Video ini ?';
                            dialogConfirm2.open = true;
                            dialogConfirm2.function = 'onDuplicateConfirm';
                        "
                        >Simpan</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTableModule";
import ItembankService from "@/modules/itembank/services/itembank.js";
import VideoService from "@/modules/vd_pembelajaran/services/video.js";
import DialogConfirm from "@/modules/global/components/DialogConfirm";

export default {
    name: "vide0-pembelajaran",
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: "Default Title",
        // all titles will be injected into this template
        titleTemplate: "%s | My Awesome Webapp",
    },
    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
        "dialog-confirm": DialogConfirm,
    },

    data() {
        return {
            search: null,
            videoList: [],
            details: "",
            selectedRow: null,
            isLoading: true,
            total_data: 0,
            currentPage: 1,
            total_count: 0,
            total_published: 0,
            kurikulum: "",
            subject: "",
            grade: "",
            bab: "",
            status: "",
            headers: [
                { text: "Judul", value: "title", width: 300 },
                { text: "Kelas", value: "grade" },
                { text: "Mata Pelajaran", value: "mapel" },
                { text: "Bab", value: "bab" },
                { text: "Sub Bab", value: "subab" },
                { text: "Sub Sub Bab", value: "subsubab" },
                { text: "Nomor Urut", value: "queue" },
                { text: "Status", value: "status" },
                { text: "Jumlah Akses", value: "access" },
                { text: "Aksi", value: "actions" },
            ],
            headersKey: [
                "title",
                "grade",
                "mapel",
                "bab",
                "subab",
                "subsubab",
                "queus",
                "status",
                "access",
            ],
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
            dialogConfirm2: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            tablekey: 0,
            showModal: false,
            total_data_per_page: 10,
            total_pages: 0,
            sortBy: "",
            filters: [],
            gradeList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            topics: [],
            mapelList: JSON.parse(localStorage.getItem("mapels")),
            params: {
                page: 1,
                table_key: "",
                search: "",
                sort_by: "desc",
                sort_mode: "",
                size: 10,
                title: "",
                mapel: "",
                subject: "",
                grade: "",
                bab: "",
                kurikulum: "",
                status: "",
            },
        };
    },

    watch: {
        search() {
            this.fetchData();
        },
        pagination() {
            this.fetchData();
        },
    },

    mounted: function () {
        this.fetchData();
        this.fetchCount();
        this.$store.commit("video_reset");
    },

    methods: {
        playing() {
            console.log("o/ we are watching!!!");
        },

        fetchData: function () {
            var context = this;
            context.isLoading = true;

            if (context.search === null) {
                context.search = "";
            }

            const current_page =
                context.pagination.currentPage > 0
                    ? context.pagination.currentPage - 1
                    : 0;

            this.params = {
                page: current_page,
                sort_by: context.sortBy,
                sort_mode: context.pagination.sortMode,
                size: context.total_data_per_page,
                title: "",
                mapel: "",
                subject: context.subject,
                grade: context.grade,
                bab: context.bab,
                kurikulum: context.kurikulum,
                status: context.status,
                search: context.search,
            };

            if (this.filters.length > 0) {
                this.filters.forEach((filter, index) => {
                    if (filter.key.value === "title") {
                        this.params.title = filter.value;
                    }
                    if (filter.key.value === "mapel") {
                        this.params.mapel = filter.value;
                    }
                    if (filter.key.value === "grade") {
                        this.params.grade = filter.value;
                    }
                    if (filter.key.value === "bab") {
                        this.params.bab = filter.value;
                    }
                });
            }

            VideoService.getListVideo(this.params, (result) => {
                context.videoList = [];

                if (result.success) {
                    this.total_data = result.data.total_videos;
                    this.total_pages = Math.floor(
                        this.total_data / this.total_data_per_page
                    );

                    result.data.list_of_videos.forEach((video, index) => {
                        var gradeWrap = "";
                        if (video.grades.length > 0) {
                            video.grades = video.grades.sort(function (a, b) {
                                return a.grade - b.grade;
                            });
                            for (var i = 0; i < video.grades.length; i++) {
                                if (i + 1 == video.grades.length) {
                                    gradeWrap += video.grades[i].grade;
                                } else {
                                    gradeWrap += video.grades[i].grade + ", ";
                                }
                            }
                        } else {
                            gradeWrap = "";
                        }
                        var row = {
                            no: index,
                            id: video.id,
                            title: video.title,
                            grade: gradeWrap,
                            mapel: video.mapel.nama,
                            bab: video.bab ? video.bab.nama : "",
                            subab: video.sub_bab_id
                                ? video.sub_bab_id.nama
                                : "",
                            subsubab: video.sub_sub_bab_id
                                ? video.sub_sub_bab_id.nama
                                : "",

                            queue: video.no_urut,
                            status: video.status,
                            access: video.total_access,
                        };
                        context.videoList.push(row);
                    });
                }
                context.isLoading = false;
            });
        },

        fetchCount: function () {
            var context = this;
            this.isLoading = true;

            VideoService.getCountVideo(function (result) {
                if (result.success) {
                    context.total_count = result.data.total_count;
                    context.total_published = result.data.total_published;
                }
                context.isLoading = false;
            });
        },

        getMapelByName: function () {
            var bab = this.subject;
            var mapel = JSON.parse(localStorage.getItem("mapels"));
            var found = mapel.find(function (element) {
                return element.nama == bab;
            });

            this.getTopics(found.id);

            return found;
        },

        getTopics(id) {
            var context = this;
            var mapelId = id;

            if (mapelId) {
                mapelId =
                    mapelId.toString().length === 1
                        ? `0${mapelId}`
                        : mapelId.toString();

                ItembankService.getListOfTopic(mapelId, function (result) {
                    context.topics = result.data;
                });
            }

            context.fetchData();
        },

        duplicateItem() {
            var context = this;

            context.details = "";
            VideoService.getVideoDetailById(
                context.selectedRow.id,
                function (result) {
                    context.details = result.data;
                    context.details.title = "Duplikat " + context.details.title;

                    context.showModal = true;
                }
            );
        },

        onDuplicateConfirm() {
            const context = this;
            const datafull = this.details;
            context.isLoading = true;

            var gradeWrap = [];
            var jenjangWrap = "";
            if (datafull.grades.length > 0) {
                for (var i = 0; i < datafull.grades.length; i++) {
                    gradeWrap.push(datafull.grades[i].grade);
                    jenjangWrap = datafull.grades[i].jenjang.nama;
                }
            }

            var video = {
                title: datafull.title,
                description: datafull.description,
                interest: datafull.interest,
                source: datafull.source,
                youtube_url: datafull.youtube_url,
                grades: gradeWrap,
                type: datafull.type,
                mapel_id: datafull.mapel.id,
                bab_id: datafull.bab.id,
                subbab_id: datafull.sub_bab_id.id,
                subsubbab_id: datafull.sub_sub_bab_id.id,
                duration: datafull.duration,
                no_urut: datafull.no_urut,
                module_id: datafull.module_id,
                user_group: datafull.user_group,
                kurikulum: datafull.kurikulum,
                status: datafull.status,
                id: datafull.id,
            };

            VideoService.duplicateVideo(video, (result) => {
                if (result.success) {
                    context.$store.commit("showAlert", {
                        message: `Dupikasi Video Berhasil!`,
                        type: "success",
                    });
                    context.isLoading = false;
                    context.showModal = false;
                    context.fetchData();
                    context.tableKey++;
                } else {
                    context.$store.commit("showAlert", {
                        message: `Gagal melakukan duplikasi!`,
                        submessage: result.message,
                        type: "error",
                    });
                    context.isLoading = true;
                    context.showModal = false;
                    context.fetchData();
                    context.tableKey++;
                }
            });

            this.selectedRow = null;
            this.dialogConfirm2.open = false;
            this.showModal = false;
        },

        onDuplicateCancel() {
            this.selectedRow = null;
            this.dialogConfirm2.open = false;
            this.showModal = false;
            this.fetchData();
        },

        doSearch() {
            var context = this;
            context.pagination.currentPage = 1;
            this.fetchData();
        },

        delByOneFilter(filter) {
            this.clearFilter();
            filter.value = "";
            var index = this.filters.push(filter) - 1;
            this.fetchData();
            this.filters.splice(index, 1);
        },

        clearFilter() {
            this.params = {
                page: 1,
                table_key: "",
                search: "",
                sort_by: "desc",
                sort_mode: "",
                size: 10,
                title: "",
                mapel: "",
                grade: "",
                bab: "",
            };
        },

        createVideo: function () {
            this.$router.push({ path: "/video/form" });
        },

        editVideo: function () {
            var videoId = this.selectedRow.id;
            this.$router.push({ path: "/video/form", query: { id: videoId } });
        },

        reportVideo() {
            this.$router.push({ path: "/video/report" });
        },

        confirmDelete: function (video) {
            this.dialogConfirm.title = "Hapus Video Pembelajaran";
            this.dialogConfirm.subtitle =
                "Apakah Anda yakin akan menghapus video pembelajaran ini?";
            this.dialogConfirm.function = video;
            this.dialogConfirm.open = true;
        },

        deleteVideo: function (video) {
            var context = this;
            var videoId = video.id;

            VideoService.deleteVideo(videoId, (result) => {
                if (result.success) {
                    context.$store.commit("showAlert", {
                        message: `Data Terhapus`,
                        type: "success",
                    });
                    context.isLoading = false;
                    context.fetchData();
                } else {
                    context.$store.commit("showAlert", {
                        message: `Data gagal terhapus`,
                        type: "error",
                    });
                }
                return;
            });

            this.dialogConfirm.open = false;
            this.dialogConfirm.title = null;
            this.dialogConfirm.function = null;
        },
        openNewTab() {
            var id = this.selectedRow.id;
            const routeData = this.$router.resolve({
                path: "/video/form",
                query: { id: id },
            });
            window.open(routeData.href, "_blank");
            // this.$router.push({ path: "/video/form", query: { id: id } });
        },
    },
};
</script>



// WEBPACK FOOTER //
// VdPembelajaran.vue?7607f1e2